<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 系统管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>租户列表</el-breadcrumb-item>
				<el-breadcrumb-item>续期详情</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column prop="validTime" label="有效期"></el-table-column>
                <el-table-column prop="createBy" label="操作人"></el-table-column>
				<el-table-column prop="createTime" label="操作时间"></el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
                >添加记录</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="40%">
            <el-form ref="form" :model="form" label-width="80px" :rules="rules">
				<el-input v-model="form.applyCompanyId" v-if = "false"></el-input>
				<el-form-item label="有效期" prop="validTime">
					<el-date-picker
						type="date"
						placeholder="选择日期"
						v-model="form.validTime"
						value-format="yyyy-MM-dd"
						style="width: 100%;"
					></el-date-picker>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { getRenewalPages, renewal, getApplyCompany } from '../../../api/index';
export default {
    name: 'apply-company-renewal',
    data() {
        return {
            query: {
				applyCompanyId : this.$route.query.id,
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            pageTotal: 0,
            form: {
				applyCompanyId : this.$route.query.id
			},
            idx: -1,
            id: -1,
			rules:{
				validTime: [{ required: true, message: '有效期不能为空', trigger: 'blur' }]
			},
			controll:{}
        };
    },
    created() {
		this.controll = getControll("apply-company-renewal");
        this.getData();
    },
    methods: {
        // 获取 easy-mock 的模拟数据
        getData() {
			const id = this.$route.query.id;
			if (!id) {
				this.$message.error("参数错误！");
				return;
			}
            getRenewalPages(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
		//添加操作
		handleAdd() {
			this.isDisabled = false;
			this.title = "添加新纪录";
			this.editVisible = true;
		},
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					renewal(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							//this.$message.success(`修改第 ${this.idx + 1} 行成功`);
							if (typeof(this.form.id) == "undefined") {
								this.getData();
							} else {
								this.$set(this.tableData, this.idx, this.form);
							}
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
